import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class ClsModel extends BaseModel {
  uuid = null;
  comment = null;
  title = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    title: 'required'
  };

  attributeHints = {
  };

  attributeLabels = {
    comment: i18n.t('Comment'),
    title: i18n.t('Title'),
  }

}
